import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { HintBox, Widget } from '../../../../components';
import { useAccount, useStore } from '../../../../store';
import { ProductHelp } from '../../../../store/constants/help';
import Product from '../../store/Product';
import GeneratePanel from './components/GeneratePanel';
import ImportPanel from './components/ImportPanel';
import KeyStatsPanel from './components/KeyStatsPanel';
import SettingsPanel from './components/SettingsPanel';
import UnusedKeysPanel from './components/UnusedKeysPanel';

export default observer(function PulseKeysPanel({
  product,
}: {
  product: Product;
}) {
  const { pulseKeyStore } = useStore();
  const { isWebhookEnabled } = useAccount();

  const unusedKeysQuery = useMemo(
    () => pulseKeyStore.createUnusedProductKeyQuery(product.id),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [product.id],
  );

  return (
    <>
      {isWebhookEnabled && <SettingsPanel product={product} />}

      <Widget surface="gray" sx={{ mt: 3 }} title="Create new Pulse Keys">
        <Grid container spacing={4}>
          <Grid item xs={8}>
            <GeneratePanel
              onCreated={unusedKeysQuery.execute}
              productId={product.id}
            />
          </Grid>
          <Grid item xs={4}>
            <HintBox help={ProductHelp.generatePulseKeys} sx={{ mt: 0 }} />
          </Grid>
        </Grid>
      </Widget>

      <Widget surface="gray" sx={{ mt: 3 }} title="Import Serial Numbers">
        <Grid container spacing={4}>
          <Grid item xs={8}>
            <ImportPanel
              onImport={unusedKeysQuery.execute}
              productId={product.id}
            />
          </Grid>
          <Grid item xs={4}>
            <HintBox help={ProductHelp.importSerials} sx={{ mt: 0 }} />
          </Grid>
        </Grid>
      </Widget>

      <Widget surface="gray" sx={{ mt: 3 }} title="Export Pulse Keys">
        <Grid container spacing={4}>
          <Grid item xs={8}>
            <UnusedKeysPanel query={unusedKeysQuery} />
          </Grid>
          <Grid item xs={4}>
            <HintBox help={ProductHelp.exportPulseKeys} sx={{ mt: 0 }} />
          </Grid>
        </Grid>
      </Widget>

      <Widget surface="gray" sx={{ mt: 3 }} title="Pulse Keys Statistics">
        <KeyStatsPanel productId={product.id} />
      </Widget>
    </>
  );
});
